import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotifyRoutingModule } from './notify-routing.module';
import { NotifyComponent } from './notify.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [NotifyComponent],
  imports: [
    CommonModule,
    NotifyRoutingModule,
    TranslateModule,
    MaterialModule,
    SharedModule
  ]
})
export class NotifyModule { }
